import classNames from 'classnames/bind';
import Popup from 'mcs-toolkit/components/Popup';
import React from 'react';
import { PopupProps } from 'semantic-ui-react';

import styles from './Tooltip.css';

const css = classNames.bind(styles);

export type TooltipSection = {
    title?: string;
    className?: string;
    content: JSX.Element;
};

type TooltipProps = PopupProps & {
    triggerClassName?: string;
    triggerDataTest?: string;
    sections?: TooltipSection[];
    sectionClassName?: string;
    innerRef?(el: HTMLElement): void;
    menuTooltip?: boolean;
};

export class Tooltip extends React.Component<TooltipProps> {
    static defaultProps = {
        triggerDataTest: 'tooltip-trigger',
    };

    renderContent() {
        let sections: TooltipSection[] = [];
        if (this.props.content) {
            sections.push({
                content: this.props.content as any,
            });
        }
        if (this.props.sections) {
            sections = sections.concat(this.props.sections);
        }
        if (sections.length === 0) {
            return null;
        }
        return sections.map(this.renderSection);
    }

    renderSection = (section: TooltipSection, index: number) => {
        return (
            <div
                className={css(
                    'section',
                    section.className,
                    this.props.sectionClassName,
                )}
                key={index}
            >
                {section.title && (
                    <div className={css('sectionTitle')}>{section.title}</div>
                )}
                {section.content}
            </div>
        );
    };

    render() {
        const {
            trigger,
            header,
            position,
            sectionClassName,
            sections,
            innerRef,
            menuTooltip,
            triggerClassName,
            triggerDataTest,
            popupMenuDisabled,
            ...popupProps
        } = this.props;

        const isMenuTooltip = menuTooltip || this.props.sections;
        const content = isMenuTooltip
            ? this.renderContent()
            : this.props.content;

        return (
            <Popup
                data-test="tooltip-content"
                {...popupProps}
                className={css('root', this.props.className, {
                    menuTooltip: isMenuTooltip,
                })}
                trigger={
                    <span
                        className={css(
                            'triggerWrapper',
                            this.props.triggerClassName,
                        )}
                    >
                        <span
                            data-test={triggerDataTest}
                            className={css('trigger')}
                        >
                            {this.props.trigger}
                        </span>
                    </span>
                }
                header={header}
                content={content}
                position={position}
                hoverable
                disabled={!content}
            />
        );
    }
}
